import { render, staticRenderFns } from "./AddChild1.vue?vue&type=template&id=5b627319&scoped=true"
import script from "./AddChild1.vue?vue&type=script&lang=js"
export * from "./AddChild1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b627319",
  null
  
)

export default component.exports